import React, {useEffect, useState} from 'react';
import axios from "axios";
import {addFunc, bolFunc, fixIt} from "../../../../../../../../components/functions/Mathematik";
import {user_data} from "../../../../../../../../components/functions/usr";
import decade_days, {gmslar} from "../../../../../../../../components/sfr/maydon";
import {header} from "../../../../../../../../components/api/Header";
import { getEnv } from "../../../../../../../../lib/env";

function Limit2() {
    const lkoifsent = localStorage.getItem('sfr-hm-noveg-koifsent') ? localStorage.getItem('sfr-hm-noveg-koifsent') : 1
    const user = user_data()
    const year = localStorage.getItem('sfr-hm-year') ? localStorage.getItem('sfr-hm-year') : new Date().getFullYear()
    const manba = localStorage.getItem("sfr-hm-manbalar")
    const manbalar = manba ? JSON.parse(manba) : []
    const ist = localStorage.getItem("sfr-hm-istemolchilar")
    const istemolchilar = ist ? JSON.parse(ist) : []
    const [swed, setSwed] = useState({})
    const ekin = localStorage.getItem("sfr-hm-noveg-ekinlar")
    const ekinlar = ekin ? JSON.parse(ekin) : {}
    const ste1 = localStorage.getItem("sfr-hm-ste")
    const ste = ste1 ? JSON.parse(ste1) : {}
    const sfrMaydon = localStorage.getItem("sfr-hm-noveg-maydon")
    const sfrMaydonlar = sfrMaydon ? JSON.parse(sfrMaydon) : {}
    const [maydonlar, setMaydonlar] = useState({})
    const daysindek = decade_days('noveg', year)
    const cropid = localStorage.getItem('sfr-hm-noveg-ekinids')
    const cropids = cropid ? JSON.parse(cropid) : []


    useEffect(() => {
        let gmss = []
        const fetchSwed = async (gmss, gmss2) => {
            const postData = {
                crops: cropids,
                gmss,
                maydonlar: gmss2,
                tomorqa1: false
            }
            const res = await axios.post(
                getEnv('REACT_APP_BASE_URL') + "/v1/district/sfrmain/noveg_sugorish_meyyori2",
                postData,
                header()
            )
                .catch(e => {
                    console.log("Xato", e)
                })
            if (res) {
                setSwed(res.data)
            }
        }
        const maydon = () => {
            let gidromodullar = []
            istemolchilar.map(i => {
                if (i.gms) {
                    i.gms.map(g => {
                        if (!gidromodullar.includes(g)) {
                            gidromodullar.push(g)
                        }
                    })
                }
            })
            gmss = gidromodullar
        }
        maydon()
        const gmss2 = gmslar(sfrMaydonlar, cropids)
        setMaydonlar(gmss2)
        if (gmss2)
            fetchSwed(gmss, gmss2)
    }, [])
    const ff = (ist) => {
        let res = 0
        Object.keys(ekinlar).map(e => {
            for (let deks = 1; deks < 19; deks++) {
                if (swed[e.slice(1)]) {
                    if (ist.gms) {
                        let ed = 0
                        ist.gms.map(gms2 => {
                            if (swed[e.slice(1)][gms2]) {
                                let jm = maydonlar['g' + gms2] ? maydonlar['g' + gms2][e] : 0
                                let im = sfrMaydonlar['i' + ist.id] ? sfrMaydonlar['i' + ist.id]['g' + gms2] ? sfrMaydonlar['i' + ist.id]['g' + gms2][e] : 0 : 0
                                let ds = swed[e.slice(1)][gms2][deks]
                                ed = addFunc(ed, (bolFunc(im, jm) * ds))
                            }
                        })
                        res = addFunc(res, bolFunc(ed, ist.fik))
                    }
                }
            }
        })
        return res
    }
    const xisobot = () => {
        let obj = [];
        let counter = 1;
        let js = [0, 0, 0, 0, 0]
        let jami_limit_boyicha = [0,0,0,0,0]
        manbalar.map((manba, m) => {
            js = [0, 0, 0, 0, 0]
            let istemolchi = istemolchilar.filter(istemolchi => istemolchi.mid == manba.id)
            if (istemolchi.length) {
                istemolchi.map(ist => {
                    let iks = ff(ist)
                    let rd = bolFunc(iks, 1000) * lkoifsent
                    js[0] = addFunc(js[0], rd)
                    let istLims = [0, 0, 0, 0]
                    if (ist.limit) {
                        istLims[0] = rd - ist.limit.daryo - ist.limit.yer - ist.limit.zovur
                        istLims[1] = ist.limit.daryo
                        istLims[2] = ist.limit.yer
                        istLims[3] = ist.limit.zovur
                        js[2] = addFunc(js[2], ist.limit.daryo)
                        js[3] = addFunc(js[3], ist.limit.yer)
                        js[4] = addFunc(js[4], ist.limit.zovur)
                    }
                    js[1] = addFunc(js[1], istLims[0])
                    obj.push(
                        <tr key={counter}>
                            <td>{counter++}</td>
                            <td className="text-start">{ist.name}</td>
                            <td className="text-center">{fixIt(rd, 3)}</td>
                            <td className="text-center">{istLims[0] ? fixIt(istLims[0], 3) : ''}</td>
                            <td className="text-center">{istLims[1] ? fixIt(istLims[1]) : ''}</td>
                            <td className="text-center">{istLims[2] ? fixIt(istLims[2]) : ''}</td>
                            <td className="text-center">{istLims[3] ? fixIt(istLims[3]) : ''}</td>
                        </tr>
                    )
                })
                let sanoats = ste.filter(st => st.manba == manba.id)
                if (sanoats.length) {
                    sanoats.map(sanoat => {
                        const fik = manba.fik
                        let sol = 0
                        for (var si = 1; si < 19; si++) {
                            let l52 = sanoat['d' + si] * (0.0864 * daysindek['d' + si])
                            sol = addFunc(sol, l52)
                        }
                        let res = bolFunc(bolFunc(sol, 1000), fik)
                        js[0] = addFunc(js[0], res)
                        let sanLims = [0, 0, 0, 0]
                        if (sanoat.limit) {
                            sanLims[0] = res - sanoat.limit.daryo - sanoat.limit.yer - sanoat.limit.zovur
                            sanLims[1] = sanoat.limit.daryo
                            sanLims[2] = sanoat.limit.yer
                            sanLims[3] = sanoat.limit.zovur
                            js[2] = addFunc(js[2], sanoat.limit.daryo)
                            js[3] = addFunc(js[3], sanoat.limit.yer)
                            js[4] = addFunc(js[4], sanoat.limit.zovur)
                        }
                        js[1] = addFunc(js[1], sanLims[0])
                        obj.push(
                            <tr key={counter}>
                                <td>{counter++}</td>
                                <td className="text-start">{sanoat.name}</td>
                                <td className="text-center">{fixIt(res, 3)}</td>
                                <td className="text-center">{sanLims[0] ? fixIt(sanLims[0], 3) : ''}</td>
                                <td className="text-center">{sanLims[1] ? fixIt(sanLims[1]) : ''}</td>
                                <td className="text-center">{sanLims[2] ? fixIt(sanLims[2]) : ''}</td>
                                <td className="text-center">{sanLims[3] ? fixIt(sanLims[3]) : ''}</td>
                            </tr>
                        )
                    })
                }
                obj.push(
                    <tr key={m + 'm'}>
                        <th colSpan={2} className="vertical-middle">{manba.name}</th>
                        <th className="text-center">{js[0] ? fixIt(js[0], 3) : 0}</th>
                        <th className="text-center">{js[1] ? fixIt(js[1], 3) : 0}</th>
                        <th className="text-center">{js[2] ? fixIt(js[2]) : 0}</th>
                        <th className="text-center">{js[3] ? fixIt(js[3]) : 0}</th>
                        <th className="text-center">{js[4] ? fixIt(js[4]) : 0}</th>
                    </tr>
                )
                jami_limit_boyicha[0] = addFunc(jami_limit_boyicha[0],js[0])
                jami_limit_boyicha[1] = addFunc(jami_limit_boyicha[1],js[1])
                jami_limit_boyicha[2] = addFunc(jami_limit_boyicha[2],js[2])
                jami_limit_boyicha[3] = addFunc(jami_limit_boyicha[3],js[3])
                jami_limit_boyicha[4] = addFunc(jami_limit_boyicha[4],js[4])
            }
        })
        obj.push(
            <tr key='jami_limit_boyicha'>
                <th colSpan={2} className="vertical-middle">Jami limit bo'yicha</th>
                <th className="text-center">{jami_limit_boyicha[0] ? fixIt(jami_limit_boyicha[0], 3) : 0}</th>
                <th className="text-center">{jami_limit_boyicha[1] ? fixIt(jami_limit_boyicha[1], 3) : 0}</th>
                <th className="text-center">{jami_limit_boyicha[2] ? fixIt(jami_limit_boyicha[2]) : 0}</th>
                <th className="text-center">{jami_limit_boyicha[3] ? fixIt(jami_limit_boyicha[3]) : 0}</th>
                <th className="text-center">{jami_limit_boyicha[4] ? fixIt(jami_limit_boyicha[4]) : 0}</th>
            </tr>
        )
        return obj;
    }
    return (

        <div className="row">
            <div className="col-12">
                <table className="table table-borderless">
                    <thead>
                    <tr>
                        <td colSpan={7}><h3 className="text-center">Limit - №2</h3></td>
                    </tr>
                    <tr>
                        <td colSpan={7}>
                            <h4 className="text-center">
                                {user.district} bo'yicha {year} - {parseInt(year)+1} yil nosug'orish davrida suv manbalaridan olinadigan cheklangan suv miqdori (limit)
                            </h4>
                        </td>
                    </tr>
                    </thead>
                </table>
                <div className="text-end pe-5 mx-auto"  style={{maxWidth:"700px"}}>mln.m<sup>3</sup></div>
                <div className="flex-box mx-auto"  style={{maxWidth:"700px"}}>
                    <div className="xisobotTable">
                        <table className="table table-bordered text-center xisobot3">
                            <thead className="sticky-top" style={{background: "#77adba", color: "#fff"}}>
                            <tr>
                                <th rowSpan={2} className="vertical-middle">No</th>
                                <th rowSpan={2} style={{minWidth: "170px"}} className="vertical-middle">Hududlar nomi</th>
                                <th rowSpan={2} className="vertical-middle">Jami cheklangan suv miqdori</th>
                                <th colSpan={4} className="vertical-middle">Shu jumladan</th>
                            </tr>
                            <tr>
                                <th className="vertical-middle">Daryo o'zani</th>
                                <th className="vertical-middle">Ichki daryo va soylardan</th>
                                <th className="vertical-middle">Yer osti suvlari</th>
                                <th className="vertical-middle">Qaytadan ishlatiladigan (zovur)</th>
                            </tr>
                            </thead>
                            <tbody>
                            {xisobot()}
                            </tbody>

                        </table>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default Limit2;